<angular-template tag="div">
    <ui-select
        class="sg-element vrm-select new-style vrm-select-gx"
        theme="select2"
        ng-model="model[target]"
        search-enabled="true"
        remove-selected="false"
    >
        <ui-select-match placeholder="{{placeholderTranslation}}">
            <vrm-installation-card v-props-installation="model[target]" v-props-extended="false"/>
        </ui-select-match>

        <ui-select-choices repeat="installation in model.rawInstallations | propsFilter: {name: $select.search , idSite: $select.search}" position='up'>
            <vrm-installation-card v-props-installation="installation" v-props-extended="false"/>
        </ui-select-choices>
        <ui-select-no-choice>
            <div class="dropdown-empty-container">
                <div class="title-text-empty-container" data-i18n="addinstallation.no_results">No results</div>
                <div class = "body-text-empty-container">
                    <span data-i18n="addinstallation.adjust_your_search_to_find"> Try adjusting your search to find <br /> what you are looking for </span>
                </div>
            </div>
        </ui-select-no-choice>
    </ui-select>
</angular-template>
<style scoped lang="scss"></style>
<script>
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

import Vue from 'vue';
import { Component, Prop, Model } from 'vue-property-decorator';
@Component({
    created() {
        this.placeholderTranslation = this.$t(this.placeholder, {
            i18nFallback: this.fallback,
        });
    },
})
@AngularLocaleBundle('addinstallation')
@AngularDirective('vrm-dropdown-gx')
export default class VrmDropdownGx extends Vue {
    @Prop({ type: Array, default: () => [] })
    options;
    @Prop({ type: Boolean, default: false })
    searchEnabled;
    @Prop({ type: Boolean, default: false })
    removeSelected;
    @Prop({ type: Boolean, default: false })
    disabled;
    @Prop({ type: Boolean, default: false })
    hasError;
    @Prop({ type: String, default: 'addinstallation.select_replacement_gx' })
    placeholder;
    @Prop({ type: String, default: 'Select replacement GX' })
    fallback;
    @Prop({ type: Array, default: null })
    installations;
    @Prop({ type: String, default: null })
    target;
    @Prop({ type: Object, default: null })
    model;
    @Model('input', { default: null })
    value;
}
</script>
